import { Component, Inject, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HotToastService } from "@ngneat/hot-toast";
import { EditPage } from "projects/assist/src/app/_shared/components/layout/pages/edit-page";
import { TranslationTextBasic } from "projects/assist/src/app/custom-entity/models/translation-text";
import { OrganizationPublic } from "projects/assist/src/app/organisation/models/organization";
import { OrganizationService } from "projects/assist/src/app/organisation/services/organization.service";
import { PersonDto } from "projects/assist/src/app/person/models/person";
import { Observable, forkJoin } from "rxjs";
import { MemberTeamName } from "../../../../assist/src/app/members/models/member-team";
import { TranslationTextService } from "../member/services/translate.service";

@Component({
  selector: "app-base",
  template: "base",
  styleUrls: [],
  standalone: true,
})
export class BaseComponent extends EditPage implements OnInit {
  translations!: TranslationTextBasic[];
  entityTranslations!: TranslationTextBasic[];

  organization!: OrganizationPublic;
  teamName!: MemberTeamName;
  person!: PersonDto;

  accessKey!: string;
  orgKey!: string;
  language!: string;

  constructor(
    @Inject("page") protected page: string,
    override route: ActivatedRoute,
    protected organizationService: OrganizationService,
    protected translationTextService: TranslationTextService,
    @Inject("entity") protected entity?: number | null,
    protected override modal?: NgbModal,
    protected override toast?: HotToastService
  ) {
    super(route, modal, toast);
  }

  ngOnInit() {
    this.isLoading = true;
    this.route.paramMap.subscribe((params) => {
      let accessKey = params.get("accessKey");
      let orgKey = params.get("orgKey");
      if (accessKey && orgKey) {
        this.accessKey = accessKey;
        this.orgKey = orgKey;
        this.language = params.get("language") || "NL";
        this.language = this.language.toUpperCase();
      }
      if (!accessKey && orgKey) {
        this.orgKey = orgKey;
        this.language = params.get("language") || "NL";
        this.language = this.language.toUpperCase();
      }

      this.init();
    });
  }

  override init() {
    let observables: Observable<any>[] = [];

    if (this.orgKey) {
      observables.push(this.organizationService.getByKey(this.orgKey));
      if (this.entity) {
        observables.push(this.translationTextService.getAllByEntity(this.entity, this.orgKey));
      }
      if (this.page) {
        observables.push(this.translationTextService.getAllByPage(this.page, this.orgKey));
      }

      forkJoin(observables).subscribe((results) => {
        this.organization = results[0];
        if (this.entity) {
          this.entityTranslations = results[1];
        }
        if (this.page) {
          this.translations = results[this.entity ? 2 : 1];
        }
        super.init(); // TODO: do not use editPage logic for myassist as there won't be an id in the url
      });
    } else {
      super.init();
    }
  }

  /*translate(keyword: string, language?: string): string {
    console.debug("translate");
    let translationText: string = keyword;
    if (this.translations) {
      if (!language)
        language = this.language;
      this.translations.forEach(function (translation, i) {
        if (translation.Language.Code == language && translation.Keyword.toLowerCase() == keyword.toLowerCase())
          translationText = translation.Translation;
      })
    }
    return this.replaceDefaultTags(translationText);
  }



  replaceDefaultTags(text: string): string {
    console.log(text);
    if (text && text.indexOf('[') > -1) {
      if (this.organization) {
        text = text.replace("[ORGANIZATION_NAME]", this.organization.Name);
        text = text.replace("[ORGANIZATION_SHORT]", this.organization.Short ? this.organization.Short : this.organization.Name);
      }
      if (this.person) {
        text = text.replace("[PERSON_FIRSTNAME]", this.person.FirstName);
        text = text.replace("[PERSON_LASTNAME]", this.person.LastName);
      }
      if (this.teamName) {
        text = text.replace("[TEAMNAME]", this.translate(this.teamName.Name));
        text = text.replace("[TEAMNAME-LOWER]", this.translate(this.teamName.Name.toLowerCase()));
        text = text.replace("[TEAMNAMEPLURAL]", this.translate(this.teamName.NamePlural));
        text = text.replace("[TEAMNAMEPLURAL-LOWER]", this.translate(this.teamName.NamePlural.toLowerCase()));
      }
    }
    return text;
  }*/
}
